module.exports = __webpack_public_path__ + "img/g.2e313334.jpg";